module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('el-date-picker', {
    staticClass: "activity-edit-date el_box",
    attrs: {
      "type": "datetime",
      "placeholder": "开始时间",
      "picker-options": _vm.pickerOptions,
      "value-format": "timestamp",
      "default-time": "00:00:00"
    },
    model: {
      value: (_vm.dateRange.from),
      callback: function($$v) {
        _vm.$set(_vm.dateRange, "from", $$v)
      },
      expression: "dateRange.from"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "to"
  }, [_vm._v("至")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "activity-edit-date el_box",
    attrs: {
      "type": "datetime",
      "placeholder": "终止时间",
      "picker-options": _vm.pickerOptions,
      "value-format": "timestamp",
      "default-time": "23:59:59"
    },
    model: {
      value: (_vm.dateRange.to),
      callback: function($$v) {
        _vm.$set(_vm.dateRange, "to", $$v)
      },
      expression: "dateRange.to"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b6714e0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/date-selector.vue
// module id = sso2
// module chunks = 6